import { render, staticRenderFns } from "./AutocompleteWithApi.vue?vue&type=template&id=2500e408&scoped=true&"
import script from "./AutocompleteWithApi.vue?vue&type=script&lang=js&"
export * from "./AutocompleteWithApi.vue?vue&type=script&lang=js&"
import style0 from "./AutocompleteWithApi.vue?vue&type=style&index=0&id=2500e408&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2500e408",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VAutocomplete,VCombobox})
